<!--
 * @Auther: 罗耀祖
 * @Date: 2022-02-16 16:11:54
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-09-09 15:52:44
 * @name: 待审核
 * @Description: 待审核
 * @FilePath: \project\src\views\index\afterSaleWaitApprove\afterSaleWaitApproveList\afterSaleWaitApproveList.vue
 * @Author: desktop
-->
<template>
  <div class="afterSaleWaitApproveList" id="afterSaleWaitApproveList">
    <div class="container">
      <table-search-form title="待审批列表">
        <template v-slot:searchForm>
          <div class="search-form">
            <div class="search-line">
              <div class="search-label"><font>琴号</font></div>
              <div class="search-content">
                <el-input
                  size="mini"
                  v-model="afterSaleWaitApproveListView.searchForm.piano_no"
                  placeholder="请输入琴号搜索"
                  @blur="setFocus()"
                  @keyup.native.enter="afterSaleWaitApproveListView.onQuery()"
                ></el-input>
              </div>
            </div>
            <div class="search-line">
              <div class="search-label"><font>当前状态</font></div>
              <div class="search-content">
                <div class="search-checkbox-group">
                  <el-radio-group
                    size="mini"
                    v-model="afterSaleWaitApproveListView.searchForm.type"
                    @change="setFocus()"
                  >
                    <el-radio-button
                      v-for="item of afterSaleWaitApproveListView.typeList"
                      :key="item.value"
                      :label="item.value"
                    >
                      {{ item.text }}
                    </el-radio-button>
                  </el-radio-group>
                </div>
              </div>
            </div>
            <div class="btn-group">
              <el-button
                size="mini"
                icon="el-icon-search"
                type="primary"
                id="filterSearch"
                @keyup.enter="afterSaleWaitApproveListView.onQuery()"
                @click="afterSaleWaitApproveListView.onQuery()"
                >搜索</el-button
              >
              <el-button
                size="mini"
                icon="el-icon-refresh"
                plain
                @click="afterSaleWaitApproveListView.initData()"
                >刷新</el-button
              >
            </div>
          </div>
        </template>
        <template v-slot:head></template>
        <template v-slot:table>
          <el-table
            id="table"
            :data="afterSaleWaitApproveListView.tableData"
            v-loading="afterSaleWaitApproveListView.tableLoading"
            tooltip-effect="light"
            element-loading-text="数据加载中"
            fit
            border
            :header-cell-style="{
              'background-color': $scssVars['Vars-background-bar-normal'],
              color: '#666',
            }"
            :style="{ fontSize: $scssVars['Vars-font-content-size'] }"
          >
            <el-table-column align="center" prop="id" label="ID" width="100">
            </el-table-column>
            <el-table-column
              align="center"
              prop="run_process_create_time"
              label="发起时间"
              width="150"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="agency_name"
              label="琴行名称"
              width="240"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="musical"
              label="乐器类别"
              width="150"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="piano_model"
              label="型号"
              width="150"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="piano_no"
              label="琴号"
              width="150"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="issue_name"
              label="问题类型"
              width="150"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="positions"
              label="问题部位"
              width="150"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="questions"
              label="具体问题"
              width="240"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="statuText"
              label="当前状态"
              width="150"
            >
            </el-table-column>
            <el-table-column
              align="center"
              fixed="right"
              label="操作"
              width="100"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="text"
                  @click="afterSaleWaitApproveListView.toDetail(scope.row)"
                  >查看详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </template>
        <template v-slot:pagination>
          <Pagination
            class="pagination"
            v-if="afterSaleWaitApproveListView.pagination.page"
            :page.sync="afterSaleWaitApproveListView.pagination.page"
            :page-size.sync="afterSaleWaitApproveListView.pagination.limit"
            :total="afterSaleWaitApproveListView.tableTotal"
          >
          </Pagination>
        </template>
      </table-search-form>
    </div>
  </div>
</template>
<script>
import tableSearchForm from "@/components/public/table-search-form.vue";
import afterSaleWaitApproveListView from "./afterSaleWaitApproveList.view.js";
import Pagination from "@/components/public/Pagination.vue";
import { getEventBus } from "@/config/eventBus.config.js";
import { indexRouterLinkConfig } from "@/config/indexRouterLink.config";
export default {
  name: "indexAfterSaleWaitApproveList",
  components: {
    tableSearchForm,
    Pagination,
  },
  data() {
    return {
      afterSaleWaitApproveListView: new afterSaleWaitApproveListView(),
      pageScroll: 0,
      tableScroll: 0,
    };
  },
  //记录离开时的位置
  beforeRouteLeave(to, from, next) {
    //保存滚动条元素div的scrollTop值
    this.pageScroll = document.querySelector(
      "#afterSaleWaitApproveList"
    ).scrollTop;
    this.tableScroll = document.querySelector(
      "#table .el-table__body-wrapper"
    ).scrollLeft;
    next();
  },
  watch: {
    //分页数据发送变化查询表格数据
    "afterSaleWaitApproveListView.pagination": {
      handler(nv, ov) {
        nv.page && this.afterSaleWaitApproveListView.getTableData();
      },
      immediate: false,
      deep: true,
    },
  },
  created() {
    this.afterSaleWaitApproveListView.initData();
    this.$EventBus.$on(getEventBus("待审批列表发生变更"), () => {
      this.afterSaleWaitApproveListView.getTableData();
    });
  },
  beforeDestroy() {
    this.$EventBus.$off(getEventBus("待审批列表发生变更"));
  },
  // 存在上一个页面,且上一个页面不是本页面的父页面的子级页面,重置数据
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      let needRefresh = false;
      indexRouterLinkConfig.forEach(x => {
        x.children.forEach(y => {
          if(y.url === from.path || y.url === from.redirectedFrom) {
            needRefresh = true;
          }
        })
      })
      if (needRefresh) {
        vm.afterSaleWaitApproveListView.initData();
      } else {
        vm.$nextTick(() => {
          document.querySelector("#afterSaleWaitApproveList").scrollTop =
            vm.pageScroll;
          document.querySelector("#table .el-table__body-wrapper").scrollLeft =
            vm.tableScroll;
        });
      }
    });
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 设焦点在按钮上
     */
    setFocus() {
      document.getElementById("filterSearch").focus();
    },
  },
};
</script>
<style lang="scss" scoped>
.afterSaleWaitApproveList {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .container {
    width: 100%;
    box-sizing: border-box;
    padding: 20px;
  }
}
</style>